/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { MailRequirementSetting } from '../../system-vars';
import { ContactType } from './contact-type.enum';

export const ContactRoleType = createEnum('CONTACT_ROLE_TYPE', {
  Business: 'BUSINESS',
  Individual: 'INDIVIDUAL',
});

export type ContactRoleType = EnumSet<typeof ContactRoleType>;

export const ContactDisplay = createEnum('CONTACT_DISPLAY', {
  FirstLastName: 'FIRST_LAST_NAME',
  LastFirstName: 'LAST_FIRST_NAME',
});

export type ContactDisplay = EnumSet<typeof ContactDisplay>;

export const ContactDuplicateSearchMode = createEnum('CONTACT_DUPLICATE_SEARCH_MODE', {
  BusinessName: 'BUSINESS_NAME',
  IndividualName: 'INDIVIDUAL_NAME',
  Phone1: 'PHONE_1',
  Phone2: 'PHONE_2',
});

export type ContactDuplicateSearchMode = EnumSet<typeof ContactDuplicateSearchMode>;

export type ContactDuplicateCheckDto = {
  duplicatesExist: boolean;
  numberOfFoundDuplicates: number;
};

export type ContactDuplicateFilterDto = {
  mode: ContactDuplicateSearchMode;
  name?: string;
  businessName?: string;
  firstName?: string;
  lastName?: string;
  phone1?: string;
  phone2?: string;
  contactId?: ID;
};

export type ContactDuplicateItemDto = {
  name: string;
  phones: string;
  address: string;
  id?: ID;
};

export type ContactDetailsTypeDto = {
  type: ContactType;
  assigned: boolean;
  active: boolean;
  allowed: boolean;
  visible: boolean;
  isDirty: boolean;
};

export type ContactDetailsCommonDto = {
  contactTypes: ContactDetailsTypeDto[];
  type?: ContactRoleType;
  individualName?: {
    firstName?: string;
    lastName?: string;
  };
  businessName?: string;
  isUnsubscribed: boolean;
  displayNameAs?: ContactDisplay;
  addressee?: string;
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  phone1?: string;
  phone2?: string;
  fax?: string;
  email?: string;
  otherEmails?: string;
  salutation?: string;
  contact?: string;
  memo?: string;
  mailRequirementSetting?: MailRequirementSetting;
  confirmations?: Hash<boolean>;
};
